import a from"./cake-factory";export default a(26);
